import type { PropsWithChildren } from 'react'

import { ObjectSelectionProvider } from './ObjectSelectionContext'
import { NoteEditorProvider } from './NoteEditorContext'
import { AgentCreatedProvider } from './AgentCreatedContext'
import { AgentEffectsProvider } from './AgentEffectsContext'
import { AgentEffectsLiveRegion } from '@/common/components/AgentEffectsLiveRegion'
import { ChatDockProvider } from './ChatDockContext'
import { BriefDockProvider } from './BriefDockContext'
import { DailyBriefProvider } from './DailyBriefContext'
import { ReviseSessionProvider } from './ReviseSessionContext'
import { ModulePaneProvider } from './ModulePaneContext'
import { ChatAgentScopeProvider } from './ChatAgentScopeContext'

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <AgentEffectsProvider>
      <AgentEffectsLiveRegion />
      <AgentCreatedProvider>
        <ObjectSelectionProvider>
          <NoteEditorProvider>
            <ChatDockProvider>
              <BriefDockProvider>
                <DailyBriefProvider>
                  <ReviseSessionProvider>
                    <ModulePaneProvider>
                      <ChatAgentScopeProvider>
                        {children}
                      </ChatAgentScopeProvider>
                    </ModulePaneProvider>
                  </ReviseSessionProvider>
                </DailyBriefProvider>
              </BriefDockProvider>
            </ChatDockProvider>
          </NoteEditorProvider>
        </ObjectSelectionProvider>
      </AgentCreatedProvider>
    </AgentEffectsProvider>
  )
}
